import { Component, OnInit, Input } from '@angular/core';
import { InputTypes } from './widgets.helper';

@Component({
  selector: 'app-widgets',
  templateUrl: './widgets.component.html',
  styleUrls: ['./widgets.component.css']
})
export class WidgetsComponent implements OnInit {
  @Input()
  record: any;
  @Input()
  widget: any;
  @Input()
  input: any;
  @Input()
  fields: any;

  // field type
  fieldType: string;

  constructor() {
    this.callAction = this.callAction.bind(this);
  }

  ngOnInit() {
    this.widget.addEventListener('action', this.callAction, false);
  }

  callAction({ detail }: any) {
    switch (detail.actionType) {
      case 'setValue':
        this.setValue(detail);
        break;
      case 'addComment':
        this.addComment(detail);
        break;
    }
  }

  setValue(action: any) {
    this.fieldType = this.fields[action.key];

    switch (this.fieldType) {
      case InputTypes.COMMENTS:
        console.error('Cannot call set value on comments type');
        break;
      case InputTypes.VALUES_LIST_SINGLE:
        this.record[action.key].value = action.value;
        break;
      case InputTypes.VALUES_LIST_MULTIPLE:
        const actionValues = [];
        action.value.forEach(el => {
          const match = this.record[action.key].find(v => v.name === el);
          actionValues.push({
            id: match ? match.id : undefined,
            value: el
          });
        });
        this.record[action.key] = actionValues;
        break;
      default:
        this.record[action.key] = action.value;
    }
  }

  addComment(action: any) {
    this.fieldType = this.fields[action.key];
    if (this.fieldType !== InputTypes.COMMENTS) {
      console.error('Cannot call add comment on non-comment type');
      return;
    }
    this.record[action.key].push({
      createdByUser: {
        id: 'aeSBIhmYjAAV5lTKG',
        name: 'admin'
      },
      createdDate: new Date(),
      message: action.value
    });
  }
}
